import React from 'react';
import { observer } from 'mobx-react-lite';
import { useToastNotifications } from './use-toast-notifications';

export const ToastNotifications: React.FC = observer(() => {
  useToastNotifications();
  return null;
});
